import en from './en';

const ja = { ...en };

export default ja;
